import FilterRowViewModel from './FilterRowViewModel';
import _ from 'lodash';
import { action, computed, observable, makeObservable } from 'mobx';
import NumericInequalityFilterRow from 'main/stores/reports/NumericInequalityFilterRow';

class NumericFilterRowViewModel extends FilterRowViewModel {
  mapItem;

  operatorOpen = false;
  inputOpen = false;

  constructor({define}) {
    super(define);

    makeObservable(this, {
      operatorOpen: observable,
      inputOpen: observable,
      closeDropdowns: action,
      openOperator: action,
      closeOperator: action,
      openInput: action,
      closeInput: action,
      updateInput: action,
      updateInputStartRange: action,
      updateInputEndRange: action,
      operatorView: action,
      isRangeOperator: computed,
      inputView: computed,
      inputRangeView: computed
    });
  }

  createRow(row) {
    return new NumericInequalityFilterRow(row);
  }

  closeDropdowns() {
    this.closeOperator();
    this.closeInput();
  }

  openOperator() {
    this.closeInput();
    this.operatorOpen = true;
  }

  closeOperator() {
    this.operatorOpen = false;
    this.resetRow();
  }

  openInput() {
    this.closeOperator();
    this.inputOpen = true;
  }

  closeInput() {
    this.inputOpen = false;
    this.resetRow();
  }

  updateInput(value) {
    this.editingRow.updateValue(value);
  }

  updateInputStartRange(value) {
    this.editingRow.updateRangeLowerBound(value);
  }

  updateInputEndRange(value) {
    this.editingRow.updateRangeUpperBound(value);
  }

  operatorView(operator) {
    switch (operator) {
      case '<=':
        return 'less_than_or_equal_to';
      case '>=':
        return 'more_than_or_equal_to';
      default:
        return 'between';
    }
  }

  get isRangeOperator() {
    return this.editingRow.operator === 'between';
  }

  get inputView() {
    const {value} = this.editingRow;
    if (_.isNil(value)) return [];

    return [value];
  }

  get inputRangeView() {
    const {lower_bound, upper_bound} = this.editingRow.range;
    if (_.isNil(lower_bound) || _.isNil(upper_bound)) return [];

    return [lower_bound, upper_bound];
  }
}

export default NumericFilterRowViewModel;
